
import { useQuery } from "@tanstack/react-query";
import { activityService } from "services";

export function useActivity() {

    const getList = async (projectId, page = 1) => {
        const data = await activityService.onGetList(projectId, page);
        return data;
    };

    const fetchData = (projectId, currentPage, isFetch = 1) => {
        return useQuery({
            queryKey: ['activity', projectId, currentPage, isFetch],
            queryFn: () => getList(projectId, currentPage),
            // enabled: !!projectId,
            staleTime: 1000 * 60 * 3,
            select: (data) => ({
                data: data?.data,
                totalPage: data?.totalPage ?? 1,
            }),
        });
    }


    return { fetchData, getList }
}
